/*
 * zc-cart.js — native cart upsell add (Monster Cart replacement), fast path.
 * Uses Shopify's Section Rendering API so adds fetch only the drawer.
 * Also skins the drawer to match Monster Cart: relabels the total "Subtotal"
 * (Dawn ships "Estimated total") and decorates line items with compare-at + %-off.
 * The Discounts/Subtotal breakdown is NOT rendered here: it lives in Liquid
 * (snippets/cart-drawer.liquid) so it can be summed from real discount
 * allocations rather than scraped out of the DOM / compare-at prices.
 */
(function () {
  'use strict';

  function inner(html, sel) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var n = d.querySelector(sel);
    return n ? n.innerHTML : null;
  }
  function pull(html, sel) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var neu = d.querySelector(sel), cur = document.querySelector(sel);
    if (neu && cur) cur.innerHTML = neu.innerHTML;
  }
  function reopenDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d) {
      d.classList.remove('is-empty');
      if (typeof d.open === 'function') { try { d.open(); } catch (e) {} }
    }
  }

  function money(cents) {
    var neg = cents < 0; cents = Math.abs(cents);
    var v = (cents / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (neg ? '-' : '') + '$' + v.join('.');
  }
  /* Add compare-at prices + "% OFF" badge to each cart line (Dawn omits them).
     Fallback only: the drawer's Liquid already stamps data-zc-pack / data-zc-cmp
     on every line it renders, so this no-ops unless that markup is missing. */
  function decorateLines() {
    var mapEl = document.getElementById('zc-line-compare');
    if (!mapEl) return;
    var map; try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    document.querySelectorAll('.cart-item').forEach(function (ci) {
      var q = ci.querySelector('[data-quantity-variant-id]');
      var vid = q && q.getAttribute('data-quantity-variant-id');
      var info = vid && map[vid];
      if (!info) return;
      /* Bundle lines only: label which pack it is + the per-unit price.
         Card variants are titled "N Pack" -> "12 Pack · $15.00 per card";
         Stand variants are titled "N Google Review Stands" -> "10 Stands · $15.00 per stand".
         So the customer sees how many units a line holds, not just its total price. */
      if (info.t && ci.getAttribute('data-zc-pack') !== '1') {
        var t = info.t + '', pn = 0, noun = '', packLbl = '';
        var pm = t.match(/(\d+)\s*pack/i);
        if (pm) { pn = parseInt(pm[1], 10); noun = 'card'; packLbl = t; }
        else {
          var sm = t.match(/(\d+)\s*(?:google\s+review\s+)?stands?\b/i);
          if (sm) { pn = parseInt(sm[1], 10); noun = 'stand'; packLbl = sm[1] + ' Stands'; }
        }
        if (pn > 1 && info.p > 0) {
          var nameEl = ci.querySelector('.cart-item__name');
          var host = nameEl || ci.querySelector('.cart-item__details');
          if (host) {
            ci.setAttribute('data-zc-pack', '1');
            var lbl = document.createElement('div');
            lbl.className = 'zc-pack';
            lbl.textContent = packLbl + ' · ' + money(Math.round(info.p / pn)) + ' per ' + noun;
            if (nameEl) nameEl.insertAdjacentElement('afterend', lbl); else host.insertBefore(lbl, host.firstChild);
          }
        }
      }
      if (ci.getAttribute('data-zc-cmp') === '1') return;
      if (!(info.c > info.p)) return;
      var priceDiv = ci.querySelector('.cart-item__details > .product-option');
      if (!priceDiv) return;
      var pct = Math.round((info.c - info.p) * 100 / info.c);
      ci.setAttribute('data-zc-cmp', '1');
      priceDiv.insertAdjacentHTML('beforeend', ' <s class="zc-was">' + money(info.c) + '</s> <span class="zc-off">' + pct + '% OFF</span>');
    });
  }

  /* Skin the drawer: relabel total, trust row, checkout label, header count and
     line-item compare-at. The Discounts/Subtotal rows come from Liquid. */
  function arrangeCart() {
    try {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      var tot = drawer.querySelector('.totals__total');
      if (tot && (tot.textContent || '').trim() === 'Estimated total') tot.textContent = 'Subtotal';
      /* guarantee line -> trust row */
      var g = drawer.querySelector('.zc-guarantee');
      if (g && g.getAttribute('data-zc-trust') !== '1') {
        g.setAttribute('data-zc-trust', '1');
        g.classList.add('zc-trust');
        g.removeAttribute('style');
        g.innerHTML = '<span>100,000+ Businesses</span><span>90-Day Guarantee</span>';
      }
      /* checkout button -> lock + "Secure Checkout" as REAL text (Dawn centers it). */
      var co = drawer.querySelector('#CartDrawer-Checkout');
      if (co && co.getAttribute('data-zc-co') !== '1') {
        co.setAttribute('data-zc-co', '1');
        co.innerHTML = '<svg class="zc-lock" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 1a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-1V6a5 5 0 0 0-5-5zm3 8H9V6a3 3 0 0 1 6 0v3z"/></svg><span>Secure Checkout</span>';
      }
      /* header -> "Your Cart (N)" with live item count (CSS uppercases it) */
      var head = drawer.querySelector('.drawer__heading');
      if (head) {
        var base = head.getAttribute('data-zc-base');
        if (base == null) { base = (head.textContent || '').replace(/\s*\(\d+\)\s*$/, '').trim(); head.setAttribute('data-zc-base', base); }
        var qn = 0;
        drawer.querySelectorAll('.cart-item .quantity__input').forEach(function (i) { qn += parseInt(i.value, 10) || 0; });
        var want = qn > 0 ? base + ' (' + qn + ')' : base;
        if (head.textContent !== want) head.textContent = want;
      }
      decorateLines();
    } catch (e) {}
  }
  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { setTimeout(watch, 300); return; }
    var obs, timer;
    function run() { if (obs) obs.disconnect(); arrangeCart(); if (obs) obs.observe(drawer, { childList: true, subtree: true }); }
    arrangeCart();
    obs = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(run, 60); });
    obs.observe(drawer, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', watch);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.zc-upsell__add');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    if (btn.getAttribute('data-adding') === '1') return;
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    btn.setAttribute('data-adding', '1');
    var original = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(id, 10), quantity: qty }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections) {
          if (data.sections['cart-drawer']) {
            pull(data.sections['cart-drawer'], '#CartDrawer-CartItems');
            pull(data.sections['cart-drawer'], '.cart-drawer__footer');
          }
          if (data.sections['cart-icon-bubble']) {
            var el = document.getElementById('cart-icon-bubble');
            if (el) {
              var bi = inner(data.sections['cart-icon-bubble'], '.shopify-section');
              el.innerHTML = (bi == null) ? data.sections['cart-icon-bubble'] : bi;
            }
          }
        }
        reopenDrawer();
        arrangeCart();
      })
      .catch(function () {})
      .then(function () { btn.removeAttribute('data-adding'); btn.textContent = original; });
  });
})();
